// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"blog-category-module--pageTitle---JHpS","container":"blog-category-module--container--2Dhcp"};